try {
  angular.module('doxy.templates');
} catch (e) {
  angular.module('doxy.templates', []);
}

window.importAngularTemplates = function (
  context,
  subpath = '*',
  ngmodule = `doxy.templates`
) {
  const createCache = function ($templateCache) {
    context.keys().forEach((key) => {
      if (~key.indexOf('.ngtemplate.')) return;
      const path = key
        .replace(/^\.\//, `/app/${subpath}/`)
        .replace(/\.html$/, '.html');
      $templateCache.put(path, context(key));
    });
  };

  const $injector = angular.element(window.document).injector();

  if ($injector) {
    createCache($injector.get('$templateCache'));
  } else {
    angular.module(ngmodule).run([
      '$templateCache',
      function ($templateCache) {
        createCache($templateCache);
      },
    ]);
  }
};
